import { BackendRoute } from '../../config/index';
import { QueryKey } from '../../constants/index';
import { ApiService } from '../../services/index';
import { DocusignEnvelope } from '../../types/company.types';
import { useAppMutation } from '../use-app-mutation.hook';

export type PatchEnvelopeLimitDto = {
  docusignEnvelopeLimit: number;
};

export const usePatchEnvelopeLimit = () => {
  const { mutate: patchEnvelopeLimit, isPending } = useAppMutation<
    DocusignEnvelope,
    unknown,
    { companyId: string; data: PatchEnvelopeLimitDto }
  >([QueryKey.GET_COMPANY], {
    mutationFn: ({ companyId, data }) =>
      ApiService.patch<DocusignEnvelope, PatchEnvelopeLimitDto>(
        { endpoint: BackendRoute.COMPANIES, routePath: [companyId, 'envelope-limit'] },
        { body: data },
      ),
  });
  return { patchEnvelopeLimit, isPending };
};
